function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_40",
  "data-name": "Group 40",
  transform: "translate(148.99 148.65)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_39",
  "data-name": "Group 39"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_107",
  "data-name": "Path 107",
  d: "M380.061,271.367q-.189-.016-.379-.015h-87.65a4.383,4.383,0,0,0-4.4,4.367c0,.127,0,.253.015.379l8.1,97.143A13.217,13.217,0,0,0,308.861,385.3h53.993a13.217,13.217,0,0,0,13.1-12.056l8.112-97.143A4.382,4.382,0,0,0,380.061,271.367ZM367.218,372.513a4.409,4.409,0,0,1-4.383,4.019H308.861a4.409,4.409,0,0,1-4.383-4.019l-5.491-66.1h73.74Zm6.241-74.866h-75.2l-1.459-17.53h78.123Z",
  transform: "translate(-287.634 -271.352)",
  fill: "#b4b4b4"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_42",
  "data-name": "Group 42",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_41",
  "data-name": "Group 41"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_108",
  "data-name": "Path 108",
  d: "M116.46,45.907V34.438A17.495,17.495,0,0,0,112.077,0H59.487A17.495,17.495,0,0,0,55.1,34.438V45.907a122,122,0,0,0-39.443,89.78v96.231A30.713,30.713,0,0,0,46.34,262.6h78.885A30.713,30.713,0,0,0,155.9,231.918V135.687A122,122,0,0,0,116.46,45.907ZM50.722,17.53a8.765,8.765,0,0,1,8.765-8.765h52.59a8.765,8.765,0,0,1,1.166,17.412,4.179,4.179,0,0,0-1.166-.237H59.487a4.179,4.179,0,0,0-1.166.237A8.765,8.765,0,0,1,50.722,17.53ZM62.4,51.131a4.382,4.382,0,0,0,1.468-3.278V35.06h43.825V47.853a4.382,4.382,0,0,0,1.468,3.278,113.117,113.117,0,0,1,30.844,45.14,61.536,61.536,0,0,1-52.222-4.106A69.978,69.978,0,0,0,36.51,84.876,112.993,112.993,0,0,1,62.4,51.131Zm84.736,180.787a21.939,21.939,0,0,1-21.913,21.913H46.34a21.939,21.939,0,0,1-21.913-21.913V135.687A113.072,113.072,0,0,1,31.877,95.4a61.3,61.3,0,0,1,51.565,4.383,70.015,70.015,0,0,0,59.313,4.843,112.827,112.827,0,0,1,4.383,31.063Z",
  transform: "translate(-15.662 0)",
  fill: "#b4b4b4"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Group_44",
  "data-name": "Group 44",
  transform: "translate(113.945 148.65)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_43",
  "data-name": "Group 43"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_109",
  "data-name": "Path 109",
  d: "M228.045,271.352a4.383,4.383,0,0,0-4.383,4.383v4.383a4.382,4.382,0,1,0,8.765,0v-4.383A4.383,4.383,0,0,0,228.045,271.352Z",
  transform: "translate(-223.662 -271.352)",
  fill: "#b4b4b4"
})));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Group_46",
  "data-name": "Group 46",
  transform: "translate(113.945 170.563)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_45",
  "data-name": "Group 45"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_110",
  "data-name": "Path 110",
  d: "M228.045,311.352a4.383,4.383,0,0,0-4.383,4.383v30.678a4.382,4.382,0,1,0,8.765,0V315.734A4.383,4.383,0,0,0,228.045,311.352Z",
  transform: "translate(-223.662 -311.352)",
  fill: "#b4b4b4"
})));

function SvgMilk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "milk",
    xmlns: "http://www.w3.org/2000/svg",
    width: 245.436,
    height: 262.595,
    viewBox: "0 0 245.436 262.595",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilk);
export default __webpack_public_path__ + "static/media/milk.465cf166.svg";
export { ForwardRef as ReactComponent };